<template>
  <div>
    <sections v-model="model.sections" :is-read-only="isReadOnly" />
    <div v-if="model.additionalQuestions?.length">
      <div class="section-title mb-4">
        <div class="d-inline mr-2 bg-white">
          <i class="fas fa-info-circle text-orange fa-lg" />
        </div>
        <span class="font-16 font-weight-bold">
          Preguntas Adicionales
        </span>
      </div>
      <div class="px-1">
        <questions
          has-divider
          :is-read-only="isReadOnly"
          :value="model.additionalQuestions"
        >
          <template #selected-answer-questions="{ questions }">
            <div class="px-4">
              <questions :is-read-only="isReadOnly" :value="questions" />
            </div>
          </template>
        </questions>
      </div>
    </div>
  </div>
</template>

<script>
import Sections from './components/Sections.vue';
import Questions from './components/Questions.vue';

import alert from '@/mixins/alert.mixin';

export default {
  name: 'RubricForm',
  components: {
    Sections,
    Questions,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import '@/scss/brand_variables.scss';
.section-title > div {
  border: 3px solid white;
  padding: 3px 4px;
  border-radius: 30px;
  -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
}
</style>
